// @flow
import FormControlsBadges from 'components/FormList/FormControlsBadges'
import FormControlsDownloadButton from 'components/FormList/FormControlsDownloadButton'
import FormControlsDropdownMenu from 'components/FormList/FormControlsDropdownMenu'
import FormControlsDuplicateButton from 'components/FormList/FormControlsDuplicateButton'
import FormControlsPublicLinkButton from 'components/FormList/FormControlsPublicLinkButton'
import * as React from 'react'

import { FormControlsAnalyticsFormButton } from './FormControlsAnalyticsPageButton'

type Props = {
  controlsDisabled?: boolean,
  enabled?: boolean,
  id: string | number,
  isPacket: boolean,
  onPublicFormClick: () => void,
  type?: 'form' | 'packet' | 'pdf',
  setLoading: (loading: boolean) => void,
  isInternalForm: boolean,
  measuresEnabled?: boolean,
}

function FormControls({
  controlsDisabled,
  enabled = true,
  id: resourceId,
  isInternalForm,
  isPacket,
  onPublicFormClick,
  type,
  setLoading,
  measuresEnabled,
}: Props): React.Node {
  return (
    <>
      <FormControlsBadges
        isInternalForm={isInternalForm}
        measuresEnabled={measuresEnabled}
        resourceEnabled={enabled}
        resourceType={type}
      />

      {!isPacket && (
        <FormControlsDuplicateButton
          controlsDisabled={controlsDisabled}
          resourceEnabled={enabled}
          resourceId={resourceId}
        />
      )}
      {!isPacket && (
        <FormControlsDownloadButton
          resourceEnabled={enabled}
          resourceId={resourceId}
          resourceType={type}
        />
      )}

      <FormControlsPublicLinkButton
        onPublicFormClick={onPublicFormClick}
        resourceEnabled={enabled}
        resourceId={resourceId}
      />
      <FormControlsAnalyticsFormButton
        resourceEnabled={enabled}
        resourceId={resourceId}
      />

      {/* <FormControlsKioskButton
        controlsDisabled={controlsDisabled}
        resourceEnabled={enabled}
        resourceId={resourceId}
      /> */}
      {/* <ChartLine className="text-base" /> */}
      <FormControlsDropdownMenu
        isPacket={isPacket}
        measuresEnabled={measuresEnabled}
        resourceEnabled={enabled}
        resourceId={resourceId}
        resourceType={type || (isPacket ? 'packet' : 'form')}
        setLoading={setLoading}
      />
    </>
  )
}

export default FormControls
